import base from './base'
import deliveryMng from './deliveryMng'
import dictionary from './dictionary'
import login from './login'
import pocMng from './pocMng'
import testcaseMng from './testcaseMng'
import tips from './tips'

export default {
  ...base,
  dictionary,
  login,
  testcaseMng,
  tips,
  pocMng,
  deliveryMng
}
